
<router-outlet></router-outlet>
<footer class="site-footer row">
  <div class="col-1 centered-vertically">
    <div class="version">v {{ packageVersion }}</div>
  </div>
  <div class="col-2 centered">
    <div class="language-options">
      <a class="btn btn-flat" (click)="changeLanguage('pt')">
        <img height="20" src="assets/flag-brazil.png"/>
        <span>Português</span>
      </a>
      <a class="btn btn-flat btn-with-left-icon" (click)="changeLanguage('en')">
        <img height="20" src="assets/flag-england.png" />
        <span>English</span>
      </a>
    </div>
  </div>
  <div class="col-6 reserved-rights centered">
    <div class="text-center">
      <p>
        <strong i18n="main application name|The name of the application when shown as text@@applicationName" >Reports Feed</strong>.
        <ng-container i18n="small copyright notice|A small text which indicates ownership or copyright hold reserve shown at the footer in most application pages@@copyrightNotice">All Rights Reserved.</ng-container>
        <span class="usage-terms">
          <a target="_blank" [href]="getTermsOfServiceDocUrl()" i18n="terms of service link|The text in the link that redirects the user to the terms of service and privacy policy page@@privacyPolicyLinkLabel">Terms of Service and Privacy Policy.</a>
        </span>
      </p>
    </div>
  </div>
  <div class="col-3 text-right">
    <button (click)="scrollToTopClick()" class="go-top">
      <i class="fa fa-angle-up"></i>
    </button>
  </div>
</footer>
